import { FontProperties } from "shared/datamodel/schemas/text-enabled-schema";
import ToggleButton from "./toggle-button";
import { Icon } from "../toolbar-buttons";

export default function TextProps({
  value,
  onChange,
  multi,
}: {
  value: FontProperties;
  onChange: (newStyle: FontProperties) => void;
  multi?: boolean;
}) {
  if (multi) value = 0;
  return (
    <div style={{ display: "flex", gap: "2px", alignItems: "stretch" }} data-testid="TextStyle">
      <ToggleButton
        tooltip="Bold"
        isOn={(value & FontProperties.Bold) != 0}
        onClick={() => {
          onChange(value ^ FontProperties.Bold);
        }}
        data-testid="bold"
      >
        <p
          style={{
            color: (value & FontProperties.Bold) != 0 ? "#fff" : "#C8CCD8",
            font: "500 20px Poppins",
          }}
        >
          B
        </p>
      </ToggleButton>

      <ToggleButton
        tooltip="Italic"
        isOn={(value & FontProperties.Italic) != 0}
        onClick={() => {
          onChange(value ^ FontProperties.Italic);
        }}
        data-testid="italic"
      >
        <Icon icon="icon-italic" />
      </ToggleButton>

      <ToggleButton
        tooltip="Underline"
        isOn={(value & FontProperties.Underline) != 0}
        onClick={() => {
          onChange(value ^ FontProperties.Underline);
        }}
        data-testid="underline"
      >
        <Icon icon="icon-underline" />
      </ToggleButton>

      <ToggleButton
        tooltip="Strikethrough"
        isOn={(value & FontProperties.LineThrough) != 0}
        onClick={() => {
          onChange(value ^ FontProperties.LineThrough);
        }}
        data-testid="strikethrough"
      >
        <Icon icon="icon-strikethrough" />
      </ToggleButton>
    </div>
  );
}
